import React from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import { AnimatePresence } from "framer-motion"

export const wrapRootElement = ({ element }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6LfKTwkbAAAAABaF6e_S_h3wM5S5oKOVJ7OkN3Ll"
      language="es"
      scriptProps={{
        async: true, // optional, default to false,
        defer: true, // optional, default to false
      }}
    >
      <AnimatePresence exitBeforeEnter>{element}</AnimatePresence>
    </GoogleReCaptchaProvider>
  )
}
